import {
    EditOutlined,
    DeleteOutlined,
    ImageOutlined,
    MoreHorizOutlined,
    EmojiEmotionsOutlined,
  } from "@mui/icons-material";
import EmojiPicker from 'emoji-picker-react';
  import {
    Box,
    Divider,
    Typography,
    InputBase,
    useTheme,
    Button,
    IconButton,
    useMediaQuery,
  } from "@mui/material";
  import FlexBetween from "../../components/FlexBetween";
  import Dropzone from "react-dropzone";
  import UserImage from "../../components/UserImage";
  import WidgetWrapper from "../../components/WidgetWrapper";
  import { useState, useEffect, useRef } from "react";
  import { useDispatch, useSelector } from "react-redux";
  import { setPosts } from "../../state";
import axios from "axios";


const MyPostWidget = ({ picturePath }) => {
    const dispatch = useDispatch();
    const [isImage, setIsImage] = useState(false);
    const [isEmojiPickerOpen, setIsEmojiPickerOpen] = useState(false);
    const [image, setImage] = useState(null);
    const [post, setPost] = useState("");
    const { palette } = useTheme();
    const { _id } = useSelector((state) => state.user);
    const token = useSelector((state) => state.token);
    const isNonMobileScreens = useMediaQuery("(min-width: 1000px)");
    const mediumMain = palette.neutral.mediumMain;
    const medium = palette.neutral.medium;
    const emojiPickerRef = useRef(null);

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          emojiPickerRef.current && 
          !emojiPickerRef.current.contains(event.target) &&
          !event.target.closest('#emoji-toggle-btn')
        ) {
          setIsEmojiPickerOpen(false);
        }
      };

      if (isEmojiPickerOpen) {
        document.addEventListener("mousedown", handleClickOutside);
      }
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [isEmojiPickerOpen]);

    const handlePost = async () => {
      try {
        const formData = new FormData();
        formData.append("userId", _id);
        formData.append("description", post);
        var convertBase64;
        if (image) {
          const reader = new FileReader();
          reader.onload = (event) => {
            formData.append("picturePath", event.target.result);
            convertBase64=event.target.result
            sendPostRequest(formData, convertBase64);
          };
          reader.readAsDataURL(image);
        } else {
          sendPostRequest(formData);
        }
      } catch (error) {
        console.error("Error posting:", error);
      }
    };

    const sendPostRequest = async (formData, convertBase64) => {
      const data ={
        userId: _id,
        description: post,
        picturePath : convertBase64
      }
      try {
        const response = await axios.post(`https://dropie-service.onrender.com/posts/create`, data, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json', // Set the content type based on your data
          }});
    
        const posts = await response.data;
        dispatch(setPosts({ posts }));
        setImage(null);
        setPost("");
      } catch (error) {
        console.error("Error sending post request:", error);
      }
    };
      return (
        <WidgetWrapper>
          <FlexBetween gap="1.5rem">
            <UserImage image={picturePath} />
            <InputBase
              placeholder="What's on your mind..."
              onChange={(e) => setPost(e.target.value)}
              value={post}
              sx={{
                width: "100%",
                backgroundColor: palette.neutral.light,
                borderRadius: "2rem",
                padding: "1rem 2rem",
              }}
            />
          </FlexBetween>
          {isEmojiPickerOpen && (
            <Box mt="1rem" position="absolute" zIndex="10" ref={emojiPickerRef}>
              <EmojiPicker onEmojiClick={(emojiData) => setPost((prev) => prev + emojiData.emoji)} />
            </Box>
          )}
          {isImage && (
            <Box
              border={`1px solid ${medium}`}
              borderRadius="5px"
              mt="1rem"
              p="1rem"
            >
              <Dropzone
                acceptedFiles=".jpg,.jpeg,.png"
                multiple={false}
                onDrop={(acceptedFiles) => setImage(acceptedFiles[0])}
              >
                {({ getRootProps, getInputProps }) => (
                  <FlexBetween>
                    <Box
                      {...getRootProps()}
                      border={`2px dashed ${palette.primary.main}`}
                      p="1rem"
                      width="100%"
                      sx={{ "&:hover": { cursor: "pointer" } }}
                    >
                      <input {...getInputProps()} />
                      {!image ? (
                        <p>Add Image Here</p>
                      ) : (
                        <FlexBetween>
                          <Typography>{image.name}</Typography>
                          <EditOutlined />
                        </FlexBetween>
                      )}
                    </Box>
                    {image && (
                      <IconButton
                        onClick={() => setImage(null)}
                        sx={{ width: "15%" }}
                      >
                        <DeleteOutlined />
                      </IconButton>
                    )}
                  </FlexBetween>
                )}
              </Dropzone>
            </Box>
          )}
    
          <Divider sx={{ margin: "1.25rem 0" }} />
    
          <FlexBetween>
            <FlexBetween gap="0.25rem" onClick={() => setIsImage(!isImage)}>
              <ImageOutlined sx={{ color: mediumMain }} />
              <Typography
                color={mediumMain}
                sx={{ "&:hover": { cursor: "pointer", color: medium } }}
              >
                Image
              </Typography>
            </FlexBetween>
    
            {isNonMobileScreens ? (
              <>
                <FlexBetween id="emoji-toggle-btn" gap="0.25rem" onClick={() => setIsEmojiPickerOpen(!isEmojiPickerOpen)} sx={{ "&:hover": { cursor: "pointer", color: medium } }}>
                  <EmojiEmotionsOutlined sx={{ color: mediumMain }} />
                  <Typography color={mediumMain}>Emoji</Typography>
                </FlexBetween>
              </>
            ) : (
              <FlexBetween gap="0.25rem">
                <MoreHorizOutlined sx={{ color: mediumMain }} />
              </FlexBetween>
            )}
    
            <Button
              disabled={!post}
              onClick={handlePost}
              sx={{
                color: palette.background.alt,
                backgroundColor: palette.primary.main,
                borderRadius: "3rem",
              }}
            >
              POST
            </Button>
          </FlexBetween>
        </WidgetWrapper>
      );
}

export default MyPostWidget
